import { useState } from 'react';
import { apiErrorText, useSetTenderItemExclusionMutation } from '@shared/api';
import type { TenderItem } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { Button } from '@shared/ui/Button';
import { Muted } from './styled';
import { exclusionLabel } from './tenderLabels';

interface ExclusionCellProps {
  item: TenderItem;
  estimateId: string;
  canWrite: boolean;
}

/**
 * Решение сметчика «считать / не считать» по позиции.
 *
 * Материал и оборудование поставки Заказчика в смету подрядчика не входят, но
 * из ведомости их не выбрасывают: строка остаётся видимой, а из «Итого»
 * выпадает. Отдельно от шифра: там решается, ЧЕМ считать, здесь — считать ли
 * вообще, и по кнопке видно, что это решение человека, а не пропуск подбора.
 */
export function ExclusionCell({ item, estimateId, canWrite }: ExclusionCellProps) {
  const [setExclusion, { isLoading }] = useSetTenderItemExclusionMutation();
  const [err, setErr] = useState<string | null>(null);

  async function toggle(next: boolean) {
    setErr(null);
    try {
      await setExclusion({
        estimateId,
        itemId: item.id,
        excluded: next,
        reason: next ? 'customer_supply' : null,
      }).unwrap();
    } catch (e) {
      setErr(apiErrorText(e, 'Не удалось изменить решение'));
    }
  }

  return (
    <div>
      {item.excluded ? (
        <Badge $tone="neutral">{exclusionLabel(item.exclusion_reason)}</Badge>
      ) : (
        <span>считаем</span>
      )}
      {canWrite && (
        <Button
          $variant="ghost"
          $size="sm"
          type="button"
          disabled={isLoading}
          title={
            item.excluded
              ? 'Вернуть позицию в расчёт'
              : 'Не считать: материал или оборудование поставки Заказчика'
          }
          onClick={() => void toggle(!item.excluded)}
        >
          {item.excluded ? 'Вернуть' : 'Не считать'}
        </Button>
      )}
      {err && <Muted>{err}</Muted>}
    </div>
  );
}
